// src/design-system/states.tsx
import { AlertTriangle, Inbox, Loader2 } from "lucide-react";
import type { ReactNode } from "react";

import { errorMessage } from "@/api/errors";

import { Button } from "./Button";

export function Loading({ label = "جارٍ التحميل…" }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 p-10 text-sm text-muted-2" role="status" aria-live="polite">
      <Loader2 size={16} className="animate-spin" aria-hidden /> {label}
    </div>
  );
}

export function EmptyState({ title, hint, action }: { title: string; hint?: string; action?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-2 p-10 text-center">
      <span className="grid h-11 w-11 place-items-center rounded-full border border-line-2 text-muted-2"
        style={{ boxShadow: "0 0 18px rgba(148,180,214,.18)" }}>
        <Inbox size={20} aria-hidden />
      </span>
      <strong className="text-[14.5px] text-ink">{title}</strong>
      {hint && <span className="max-w-md text-[12.5px] text-muted-2">{hint}</span>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center gap-3 p-10 text-center" role="alert">
      <span className="grid h-11 w-11 place-items-center rounded-full" data-tone="bad"
        style={{ border: "1px solid var(--fg)", color: "var(--fg)", boxShadow: "0 0 20px rgba(240,115,106,.4)" }}>
        <AlertTriangle size={20} aria-hidden />
      </span>
      <span className="text-sm text-[#F3B9B3]">{errorMessage(error)}</span>
      {onRetry && <Button small onClick={onRetry}>إعادة المحاولة</Button>}
    </div>
  );
}
